/** Shared active-route matching for top navbar and custom enterprise sidebar. */
export function isNavActive(pathname: string, href: string): boolean {
  if (href === '/chats') {
    return pathname === href || pathname.startsWith('/chats/');
  }
  if (href === '/test-agent') {
    return pathname === href || pathname.startsWith('/test-agent/');
  }
  if (href === '/templates') {
    return pathname === href || pathname.startsWith('/templates');
  }
  if (href === '/customers') {
    return pathname === href || pathname.startsWith('/customers');
  }
  if (href === '/campaigns') {
    return pathname === href || pathname.startsWith('/campaigns');
  }
  if (href === '/sequences') {
    return pathname === href || pathname.startsWith('/sequences');
  }
  if (href === '/arbox-automations') {
    return pathname === href || pathname.startsWith('/arbox-automations');
  }
  if (href === '/triggers') {
    return pathname === href || pathname.startsWith('/triggers');
  }
  if (href === '/advanced') {
    return pathname === href || pathname.startsWith('/advanced');
  }
  if (href === '/billing') {
    return pathname === href || pathname.startsWith('/billing');
  }
  if (href === '/partners' || href.startsWith('/partners?')) {
    return pathname === '/partners' || pathname.startsWith('/partners/');
  }
  if (href === '/votes' || href.startsWith('/votes?')) {
    return pathname === '/votes';
  }
  if (href === '/tickets') {
    return pathname === href || pathname.startsWith('/ticket/');
  }
  if (href === '/admin') {
    return pathname === href || pathname.startsWith('/admin/');
  }
  if (href === '/channels') {
    return pathname === href || pathname.startsWith('/channels/');
  }
  if (href === '/dashboard') {
    return pathname === href || pathname.startsWith('/dashboard/');
  }
  if (href === '/agent') {
    return pathname === href || pathname.startsWith('/agent');
  }
  if (href === '/academy') {
    return pathname === href || pathname.startsWith('/academy/');
  }
  if (href === '/integrations') {
    return pathname === href || pathname.startsWith('/integrations/');
  }
  if (href === '/usage') {
    return pathname === href || pathname.startsWith('/usage');
  }
  if (href === '/reachstore') {
    return pathname === href || pathname.startsWith('/reachstore');
  }
  return pathname === href;
}

export function isNavDropdownActive(
  pathname: string,
  dropdownItems?: Array<{ href: string; label: string }>,
): boolean {
  if (!dropdownItems) return false;
  return dropdownItems.some((item) => isNavActive(pathname, item.href));
}
